import {Resource} from '~/app/core/common/resource';

export class OrderSchedule extends Resource {
    trackingId: number;
    status: string;
    callDate: Date;
    deliveryDate: Date;
    orderNo: number;
    release: string;
    callDateFormatted: string;
    deliveryDateFormatted: string;
    documentType: string;
}
